export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 145,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('form_label_fabricExpenseNo') || '请款单编号',
    field: 'fabricExpenseNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员',
    field: 'salesPersonName',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_fabricExpenseStatus') || '状态',
    field: 'fabricExpenseStatus',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('form_label_oaExpenseProcess') || '申请方式',
    field: 'v_oaExpenseProcess',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_payeeScmCode') || '收款供应商',
    field: 'scmName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_currencyAmount') || '费用合计',
    field: 'v_currencyAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'showAmount'
    }
  },
  {
    title: that.$l('form_label_expensePayer') || '付款公司',
    field: 'expensePayerName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_paymentMethod') || '付款方式',
    field: 'v_paymentMethod',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_fabricPaymentRequestType') || '请款类型',
    field: 'v_fabricPaymentRequestType',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_name') || '开户银行',
    field: 'bankName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_name') || '账户名称',
    field: 'bankAccountName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_no') || '银行账号',
    field: 'bankAccountNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_type') || '账户性质',
    field: 'v_bankAccountType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_kind') || '账号类别',
    field: 'v_bankAccountKind',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_costCategory') || '费用大类',
    field: 'v_costCategory',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_substituteInvoice') || '代用发票',
    field: 'substituteInvoice',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'substituteInvoice'
    }
  },
  {
    title: that.$l('table_label_forwardGeneralManager') || '转送总经理',
    field: 'forwardGeneralManager',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'forwardGeneralManager'
    }
  },
  {
    title: that.$l('table_label_businessConsumption') || '业务消费',
    field: 'businessConsumption',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'businessConsumption'
    }
  },
  {
    title: that.$l('table_label_otherSet') || '420',
    field: 'otherSet',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'otherSet'
    }
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
